import React, { useState } from "react";
import MainGalleryViewsPerDay from "./mainGalleryViewsPerDay";
import CountriesReport from "./countriesReport";
import TopPagesByProjectVisits from "./topPagesByProjectVisits";
import TopSourcesOfVisits from "./topSourcesOfVisits";
import BrowsersReport from "./browsersReport";
import DevicesReport from "./devicesReport";
import { LastRow } from "./styles";
import InputField from "../Components/input";
import { HashLink } from "react-router-hash-link";
import TopCountriesByRequests from "./topCountriesByRequests";
import { Button, Box, Center } from "@chakra-ui/react";
import AgentsVisitsReport from "./agentsVisitsReport";
import AnalyticsC from "../routes/AnalyticsC";
import Pagination from "react-js-pagination";
import TopSourcesPieChart from "./topSourcesPieChart";
import VisitPerDayGA from "./visitPerDayGA"

const DashBoard = () => {
  const viewID = "252929040";
  const cred = {
    email: "palmgold@cloudflare.titansi.net",
    authorization: "Bearer Pzl5lQ2q6F9KK6OJpWKXe5J-NhDcIegBo29AfC18", //KNbGM4xSLMDlpnQrva994ylR0q2veaYPs-LdUFyb
    zoneTag: "f7e10b9699cb07f6c53205077f5913c5", //2f8921372ec5cd9bb3fe86756387df40
  };

  return (
    <>
      <Center className="hash-cont">
        <Button marginInline={2}>
          <HashLink smooth to="/analytics#visits-per-day">
            Visits
          </HashLink>
        </Button>
        {/* <Button marginInline={2}>
          <HashLink smooth to="/analytics#top-pages">
            Page Views
          </HashLink>
        </Button> */}

        {/* <Button marginInline={2}>
          <HashLink smooth to="/analytics#top-countries">
            Countries
          </HashLink>
        </Button> */}
        <Button marginInline={2}>
          <HashLink smooth to="/analytics#top-sources">
            Sources
          </HashLink>
        </Button>
        <Button marginInline={2}>
          <HashLink smooth to="/analytics#browser-devices">
            Devices
          </HashLink>
        </Button>
      </Center>

      {/* <section id="visits-per-day">
        <AnalyticsC />
      </section> */}
      <section id="visits-per-day">
        <VisitPerDayGA viewID={viewID}/>
      </section>

      {/* <section id="top-pages">
        <TopPagesByProjectVisits
          metric={"ga:users"}
          title={"Visits"}
          viewID={viewID}
        /> */}
        {/* <MainGalleryViewsPerDay
          metric={"ga:users"}
          title={"Visits"}
          viewID={viewID}
        /> */}
      {/* </section> */}

      {/* <section id="top-countries">
        <TopCountriesByRequests cred={cred} />
      </section> */}
        {/* <CountriesReport viewID={viewID} /> */}
      <section id="top-sources">
        <TopSourcesPieChart viewID={viewID} />
      </section>
      <section id="browser-devices">
        <LastRow>
          {/* <BrowsersReport viewID={viewID} /> */}
          <DevicesReport viewID={viewID} />
        </LastRow>
      </section>
    </>
  );
};

export default DashBoard;
